import React, { useEffect, useState } from "react";
import {useNavigate, useLocation} from"react-router-dom"
import { Row, Col} from 'react-bootstrap';
import '../../assets/css/Player/dashboard.css'
import Badminton from '../../components/icons/Batminton';
import TableTennis from '../../components/icons/TableTennisIcon';
import Bowling from '../../components/icons/Bowling';
import Run from '../../components/icons/RunIcon';
import Swal from "sweetalert2";





import {CorporateStandings, UpcommingSlider, LatestMatch, Standing_tabs} from '../../components/Player/index';
import { getPlayerSports, getMatches,GetGroupStandings, GetStandings, GetGroups, Profile, Winner , isfinaldone} from '../../API/player';
import {GetTournamentLis , FilterDynamicText, getSetting
}from  '../../API/admin'
import {FetchAllPoints,WaitlistPlayersAPI, playerEnrolledSportsAPI} from '../../API/player'
import Loader from '../admin/Common/Loader';
import { NULL } from "sass";


function Home () {
    let navigate = useNavigate();
    const location = useLocation();

    const includesTe = location.pathname.includes('te') || new URLSearchParams(location.search).has('te');
    
    const [SliderImages, setSliderImages] = useState(['badminton', 'tt', 'running', 'bowling']);
    const [profile, setProfile] = useState(null);
    const [loaderStatus, setloaderStatus] = useState(true);
    const [TopLoaderStatus, setToploaderStatus] = useState(true);

    const [SelectedTournament, setSelectedTournament] = useState('');
    const [TournamentName, setTournamentName] = useState('');
    const [CorporateList, setCorporateList] = useState([]);
    const [TopPerformer, setTopPerformer] = useState(null);

    const [matches, setMatches] = useState('');
    const [latestMatch, setLatestMatch] = useState([]);
    const [completedMatches, setCompletedMatches] = useState( [ ]);
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [todayMatches, setTodayMatches] = useState([]);
    const [selfstandings, setSelfStandings] = useState([]);
    const [groupStandings, setGroupStandings] = useState([ ]    );
    const [group, setGroups] = useState([]);
    const [ownGroup,setOwnGroup] = useState([]);
    const [selectedGroup , setSelectedGroup] = useState('')
    const [selectedRound , setRound] = useState('')

    const [game, setGame] = useState('');
    const [TournamentWinner, setTournamentWinner] = useState([]);
    const [state , setstate] = useState(true);
    let [isfinal , setisfinal] = useState(false);
    let [WaitlistPlayer , setWaitlistPlayer] = useState({
        badminton: false,
        table_tenis:false,
        bowling: false,
        twok_run : false
    });
    let [enrolledSport , setEnrolledSport] = useState({
        badminton: false,
        table_tenis:false,
        bowling: false,
        twok_run : false
    });
    const [dynamicHeading, setDynamicHeading] = useState({});
    const [TournamentOff, setTournamentOff] = useState(false);

    // console.log(selectedGroup , "seletedgroup");
    useEffect(() => {
        const handelJoin = async () => {
          let res = await getSetting();
    
          if (res.status) {
    
            res.data.forEach((entry) => {
              if (game === 'Badminton'  && enrolledSport.badminton == false || game === 'TableTennis'  && enrolledSport.table_tenis == false || game === 'bowling' && enrolledSport.bowling == false || game === '2k_run' && enrolledSport.twok_run == false) { 
          console.log("in true");
                if (entry.value === "false" && entry.name === 'tournament_register') {
                  setTournamentOff(true);
                  // Swal.fire({
                  //   title: dynamicHeading.registration_closed
                  //   ? dynamicHeading.registration_closed.title ? dynamicHeading.registration_closed.title
                  //   : 'Tournament registration are closed':   'Tournament registration are closed',
                  // text: dynamicHeading.registration_closed
                  //   ? dynamicHeading.registration_closed.value
                  //   : 'You are late, tournament registration is closed, try again next time.',
                  //   icon: "error",
                  //   allowOutsideClick: false,
                  //   allowEscapeKey: false
                  // })
                } else if (entry.value === "true" && entry.name === 'tournament_register') {
                }
            } else {
              console.log("falseeeee", game , "enr", enrolledSport.table_tenis)
            }
    
            });
          } 
        //   else {
        //     enqueueSnackbar('Unable to fetch settings', { variant: 'error' });
        //   }
        }
    
          handelJoin();
      }, [])
    useEffect(()=>{
    // setloaderStatus(true);
        let token = localStorage.getItem("token");
        if(!token) {
            navigate('/login');
        } else {
            
            
            let getProfile = async () => {
                let res =  await Profile();
                // console.log("profile",res.data)
                if (res && res.status ) {
                    setProfile(res.data);

                }
            }
           let playerEnrolledSports = async () => {
            let res = await playerEnrolledSportsAPI({});
            if (res && res.data && res.data.data) {
                console.log(res.data.data.badminton);
                setEnrolledSport(prevState => {
                    let updatedState = { ...prevState };
                    
                    if (res.data.data.badminton) {
                        updatedState.badminton = true;
                    }  if (res.data.data.table_tennis ) {
                        updatedState.table_tenis = true;
                    }  if (res.data.data.bowling) {
                        updatedState.bowling = true;
                    }  if (res.data.data.twok_run ) {
                        updatedState.twok_run = true;
                    }
                    return updatedState;
                });
            } else {
                console.error("Enrolled sports data is missing", res);
            }
        }
			// callAPI()  
            getProfile();
            playerEnrolledSports();
        }

        let callAPI = async () => {
            let formData = {
              "data" : null
            }
            let res = await FilterDynamicText(formData);
            if (res && res.data.status) {
              console.log(res.data.data)
              setDynamicHeading(res.data.data)
            } 
          }
          callAPI()
    }, [])

    useEffect(() => {
        if (includesTe) {
            Swal.fire({
                title: dynamicHeading.registration_closed
                ? dynamicHeading.registration_closed.title ? dynamicHeading.registration_closed.title
                : 'Tournament registration are closed':   'Tournament registration are closed',
              text: dynamicHeading.registration_closed
                ? dynamicHeading.registration_closed.value
                : 'You are late, tournament registration is closed, try again next time.',
                icon: "error",
                allowOutsideClick : false,
                allowEscapeKey : false
    
              })
        }
    },[dynamicHeading] )
    useEffect(() => {
        let getCorporateStandings = async () => {
            if (SelectedTournament != '') {
                let FormData = {
                    "tournament_id":SelectedTournament,
                    "teamStanding" : true
                }
                  setToploaderStatus(true)
                try {
                    let res = await FetchAllPoints(FormData)

                if (res && res.data.status) {
                    // if(res.data.corporatestanding && typeof res.data.corporatestanding === 'object'){
                    //     const CorporateListData = Object.keys(res.data.corporatestanding).map(key => ({
                    //     name: key,
                    //     badminton: res.data.corporatestanding[key].badminton,
                    //     table_tennis: res.data.corporatestanding[key].table_tenis,
                    //     bowling:res.data.corporatestanding[key].bowling,
                    //     twokrun:res.data.corporatestanding[key].twokrun,
                    //     total: res.data.corporatestanding[key].total
                    //     }));
                    //     setCorporateList(CorporateListData)
                    //     setTopPerformer(res.data.data)
                    // } else {
                    //     setCorporateList([]);
                    //     setTopPerformer(null)
                    // }
console.log("(res.data.male.data", res.data)
                    if ( profile!= null && profile.gender === 'male') {
                        if(res.data.corporatestanding && typeof res.data.corporatestanding === 'object'){
                                const CorporateListData = Object.keys(res.data.corporatestanding).map(key => ({
                                name: key,
                                badminton: res.data.corporatestanding[key].badminton,
                                table_tennis: res.data.corporatestanding[key].table_tenis,
                                bowling:res.data.corporatestanding[key].bowling,
                                twokrun:res.data.corporatestanding[key].twokrun,
                                total: res.data.corporatestanding[key].total,
                                logo: res.data.corporatestanding[key].logo
                                }));
                                setCorporateList(CorporateListData)
                                setTopPerformer(res.data.male)
                        } else {
                            setCorporateList([]);
                            setTopPerformer(null)
                        }
                    } else if (profile!= null && profile.gender === 'female') {
                        if(res.data.corporatestanding && typeof res.data.corporatestanding === 'object'){
                        
                             const CorporateListData = Object.keys(res.data.corporatestanding).map(key => ({
                            name: key,
                            badminton: res.data.corporatestanding[key].badminton,
                            table_tennis: res.data.corporatestanding[key].table_tenis,
                            bowling:res.data.corporatestanding[key].bowling,
                            twokrun:res.data.corporatestanding[key].twokrun,
                            total: res.data.corporatestanding[key].total,
                            logo: res.data.corporatestanding[key].logo
                            }));
                            setCorporateList(CorporateListData)
                            setTopPerformer(res.data.female)
                        }  else {
                            setCorporateList([]);
                            setTopPerformer(null)
                        }
                    }
                }
                } catch (error) {
                    console.error('Error fetching corporate standings:', error);

                }finally {
                    setToploaderStatus(false)
                }
                
            }
            
        }
        let waitlistPlayer = async () => {
            let FormData = {
                tournament_id: SelectedTournament,
            }
            let res = await WaitlistPlayersAPI(FormData);
            console.log(res.data.totalRecords) ;
            if (res.data.totalRecords == 0) {
                // callAPI();
            } else {
                res.data.data.map((entry) => {
                    setWaitlistPlayer(prevState => {
                        let updatedState = { ...prevState };
                        
                        if (entry.game_type === 'badminton') {
                            updatedState.badminton = true;
                        } else if (entry.game_type === 'table_tenis') {
                            updatedState.table_tenis = true;
                        } else if (entry.game_type === 'bowling') {
                            updatedState.bowling = true;
                        } else if (entry.game_type === '2k_run') {
                            updatedState.twok_run = true;
                        }
                
                        return updatedState;
                    });
                });
            }
        }
        // uncomment if something wrong
        // let callAPI = async () => {
        //     let res =  await getPlayerSports();
        //     if (res.status && res.data.length === 0) {
        //        navigate('/select-sport');
        //     }
        // }
        if (SelectedTournament !== '') {
            getCorporateStandings()

            waitlistPlayer()
        }
    },[SelectedTournament, profile])
    useEffect(()=>{
        console.log("yes");
        setloaderStatus(true)
        let callAPI = async () => {
            if (SelectedTournament != '' && game != '') {
                let formData = {
                    "game" : game,
                    "tournament_id" : SelectedTournament
                }
                let res =  await getMatches(formData);
                console.log(res.data.data.today_match)
                if (res.data.status) {
                    setLatestMatch(res.data.data.latest_match);
                    setCompletedMatches(res.data.data.completed);
                    setUpcomingMatches(res.data.data.upcoming_match);
                    setTodayMatches(res.data.data.today_match);
                }

            }
        }
        let callAPI2 = async ()  => {
            if (game != '' && SelectedTournament!='') {
                
                let res = await GetStandings(game , SelectedTournament);
                console.log(res.status)
                if (res.status) {
                    setSelfStandings(res.data)
                }  else {
                    setSelfStandings([])

                }

            }
        }
        let callAPI3 = async () => {
            if (SelectedTournament != '' && game != '') {
                let FormData = {
                    "tournamentId":SelectedTournament,
                    "game_type":game,
                }
                let res = await GetGroups (FormData);
                if (res.data.status) {
                    setGroups(res.data.data.other_group);
                    setOwnGroup(res.data.data.own_group);
                    if(res.data.data.own_group!=null){
                        console.log("own group");
                        
                    setSelectedGroup(res.data.data.own_group.id);}
                    else 
                    {
                        console.log("another  group");

                        setSelectedGroup(res.data.data.other_group[0].id);
                    }
                }
             }
        }
        
        let callAPI4 = async () => {
            if (SelectedTournament != '' && game != '') {
                let FormData = {
                    "tournamentId":SelectedTournament,
                    "game_type":game,
                    
                }
                let res = await Winner (FormData);
                console.log("winnEr")
                console.log(res)
                if (res.data.status) {
                    setTournamentWinner(res.data.data)
                } 
             }
        }
        let callAPI5 = async ()  => {
            if (game != '' && SelectedTournament!='') {
                
                let res = await isfinaldone(game , SelectedTournament);
                setloaderStatus(false)
                console.log(res.status)
                if (res.status) {

                    console.log("reesssss" , res.isfinal);
                    setisfinal(res.isfinal);
                }  else {
                    setSelfStandings([])

                }

            }
        }
      
        callAPI()
        callAPI2()
        callAPI3()
        callAPI4()
        callAPI5()
        setstate(!state);

    }, [SelectedTournament, game])

    useEffect(()=>{
        let callAPI2 = async() => {
            
            let FormData = {
                'group_id' : selectedGroup!=''? selectedGroup: ownGroup
            }
         
            let res = await GetGroupStandings(FormData);
            if (res.status) {
                setGroupStandings(res.data.data);
                 console.log("group ressss",res.data.data);
            }
            else {
                // setGroupStandings([]); 
            }
        };
        if (  selectedGroup != '') {
             callAPI2();
        }
    }, [completedMatches, selectedGroup , game ])
    

    useEffect(() => {
        let GetRoundGroups = async () => {
            if (SelectedTournament != '' && game != '') {
                let FormData = {
                    "tournamentId":SelectedTournament,
                    "game_type":game,
                    "round" : selectedRound !== '' ? selectedRound: null
                }
                let res = await GetGroups (FormData);
                if (res.data.status) {
                    setGroups(res.data.data.other_group);
                    setOwnGroup(res.data.data.own_group);
                    if(res.data.data.own_group!=null){
                        console.log("Selected owen group")
                    setSelectedGroup(res.data.data.own_group.id);}
                    else 
                    {
                        console.log("Selected other group")

                        setSelectedGroup(res.data.data.other_group[0].id);
                    }
                }
             }
        }

        GetRoundGroups()
    }, [selectedRound])
    let handelChange = (value) => {
        console.log("asdlasd" + value);
        setSelectedTournament(value)
    }
    let handelGroups = (value) => {
        console.log("Grouop" + value);
        setSelectedGroup(value)
    }
    let handelRound = (value) => {
        setRound(value)
    }
    let handelGameChage = (value) => {

        setGame(value)
    }
    let tournamentName = (value) => {
        setTournamentName(value)

    }
    return (    
        <>
         {loaderStatus ? <Loader /> : null}
         {TopLoaderStatus ? <Loader /> : null}
            <Row className="mt-3 align-items-center ">
            <Col className="fs-4 fw-bold statistics_header darkSvg">
            
            {/* {
        game === 'TableTennis' ? (
            WaitlistPlayer.table_tenis || enrolledSport.table_tenis === false ? null : (
                <p>{TournamentName} <TableTennis /></p>
            )
        ) : game === 'Badminton' ? (
            WaitlistPlayer.badminton || enrolledSport.badminton === false ? null : (
                <p>{TournamentName} <Badminton /></p>
            )
        ) : game === 'bowling' ? (
            WaitlistPlayer.bowling || enrolledSport.bowling === false ? null : (
                <p>{TournamentName} <Bowling /></p>
            )
        ) : (
            WaitlistPlayer.twok_run || enrolledSport.twok_run === false ? null : (
                <p>{TournamentName} <Run /></p>
            )
        )
} */}


            </Col>
             </Row>
       
        <CorporateStandings  onValueChange={handelChange} gameType= {handelGameChage} TournamentID={SelectedTournament}  TournamentName= {tournamentName} corporate={profile} CorporateList={CorporateList}
        waitListGame={WaitlistPlayer} enrolledSport={enrolledSport}
        />
            <UpcommingSlider TodayMatch= {todayMatches}  sport = {game}  gameType= {handelGameChage} waitListGame={WaitlistPlayer}/>
            <LatestMatch latestMatch = {latestMatch} gameType= {handelGameChage} gametypes = {game} waitListGame={WaitlistPlayer} enrolledSport={enrolledSport} TournamentID={SelectedTournament} />
            <Standing_tabs onValueChange = {handelGroups}  onRoundChange= {handelRound} completed={completedMatches} selfstandings={selfstandings} groupStandings={groupStandings}  upcoming = {upcomingMatches} TournamentName={TournamentName} groups={group} ownGroup={ownGroup} TournamentWinner={TournamentWinner} showwinner={isfinal} gameType= {handelGameChage}  gametypes = {game} TopPerformer={TopPerformer} waitListGame={WaitlistPlayer} enrolledSport={enrolledSport} profile={profile}/>
        </>
    )
}
export default Home;